module.exports = __webpack_public_path__ + "img/地图综合应用.ef3720ea.svg";